<template>
	<div class="pBox" v-if="selectdItem.preStyle.selfStyle && list.length > 0"
		style="display: flex;align-items: center;">

		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>

		<div class="box" v-if="equipment == 'pc' && navEquipment == 'pc'"
			style="width: fit-content;display: flex;align-items: center;" :style="{
				...getBorder(),
				...getBorderRadius(),
				...getBg(selectdItem),
				...getPadding(selectdItem),
			}">
			<div v-for="(item,index) in list" :key="index">
				<div class="popper_list">
					<el-popover ref="popoverRef" popper-class="custom-popover"
						:disabled="item.followChild && item.cacheLinkIndex == '商品分类'?!item.followChildList || item.followChildList.length == 0 :!item.child || item.child.length == 0 && disabledPop"
						trigger="hover" placement="bottom">
						<div class="popover" :style="{
							width:item.config.isFull?getPopoverFullWidth(item):item.config.width + 'px'
						}" style="max-height: 55vh;overflow-y: auto;overflow-x: hidden;">
							<div :style="{
								 ...getPopoverPadding(item),
							 }" style="display: flex;width: 100%;flex-wrap: wrap;">
								<div :style="{
									width:item.followChild?'100%':childrenGroupItem.configWidth + 'px'
								}" style="margin: 10px;" v-for="(childrenGroupItem,childrenGroupIndex) in (item.followChild?item.followChildList: item.child)"
									:key="childrenGroupIndex">
									<div style="font-weight: bold;"
										:style="{color:item.config.titColor,fontSize: item.config.titFontSize + 'px'}">
										{{getChildrenGroupItemName(childrenGroupItem).text}}
									</div>
									<div style="margin-top: 30px;" v-if="childrenGroupItem.type == '2'">
										<a target="_self" href="javascript:void(0)">
											<img @click="hrefNavImgTo(childrenGroupItem)"
												style="width: 205px;height: 205px;"
												:src="getChildImg(childrenGroupItem).url" />
										</a>
									</div>

									<div :style="{
									}" style="margin-top: 36px;color: #7f7f7f ;" v-if="childrenGroupItem.type == '1'">
										<div @mouseleave.stop.prevent="enterChildTit = ''"
											@mouseenter.stop.prevent="enterChildTit = 'enterChildTit' + childrenIndex + childrenGroupIndex +  index"
											class="linktit" @click="hrefNavTo(childrenItem)" style="margin-top: 30px;"
											v-for="(childrenItem,childrenIndex) in childrenGroupItem.links"
											:key="childrenIndex">
											<div
												:style="{
													
													fontSize: item.config.titChildFontSize + 'px',
													color:getChildTitColor(item.config.color,compontentStyle.hoverColor,'enterChildTit' + childrenIndex + childrenGroupIndex+ index)}">
												{{getChildrenItemLinkName(childrenItem)}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div v-if="!item.addBtn" slot="reference" @mouseleave.stop.prevent="mouseleaveMore('t')"
							@mouseenter.stop.prevent="mouseenterMore(index,item)" style="position: relative;" :style="{'--hover': compontentStyle.hoverColor,
							marginLeft:index == 0?'0px':(selectdItem.preStyle.selfStyle.gap + 'px')
							}" @click="hrefNavTo(item)" class="nav_item"">
							<div style="">
								{{getChildrenGroupItemName(item).text}}
							</div>
							<i v-if=" item.followChild && item.cacheLinkIndex=='商品分类' ?item.followChildList && item.followChildList.length>
							0: item.child && item.child.length> 0" style="margin-left: 7px;"
							class="el-icon-caret-bottom"></i>
							<div v-if="getGroupLabelName(item).text"
								style="position: absolute;top: -24px;display: flex;justify-content: center;width: fit-content;margin-top: 4px;">
								<div class="qipao" :style="{backgroundColor:item.color1,color:item.color2}">
									{{getGroupLabelName(item).text}}
								</div>
							</div>
						</div>
					</el-popover>
				</div>
			</div>
		</div>
		<div style="width:fit-content;height: 100%;display: flex;align-items: center;"
			v-if="equipment == 'phone' || navEquipment == 'phone'">
			<van-icon @click="show = true" name="wap-nav" />
			<!-- <img @click="show = true" style="width: 40px;height: 40px;" src="../img/nav.png" /> -->
		</div>
		<div style="position: relative;z-index: 10000000;">
			<van-popup get-container="body" safe-area-inset-bottom lazy-render style="height: 100%;width: 280px;" position="left"
				v-model="show">
				<div
					style="border-bottom: solid 1px #d4d4d4;font-size: 18px;height: 56px;display: flex;justify-content: space-between;align-items: center;color: #000;">
					<!-- <van-icon @click="show = true" name="wap-nav" /> -->
					<div> </div>
					<i @click="show = false" style="margin-right: 20px;font-weight: none;font-size: 18px;"
						class="el-icon-s-fold"></i>
				</div>
				<el-menu class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
					<div v-for="(item,index) in list" :key="index">
						<div v-if="!item.addBtn">
							<el-submenu :unique-opened="false" style="border-bottom:solid 1px #e1e1e1;"
								v-if="item.followChild && item.cacheLinkIndex == '商品分类'? item.followChildList && item.followChildList.length > 0:(item.child && item.child.length > 0) " :index="index + ''">
								<template slot="title">
									<div @click.stop.prevent="hrefNavTo(item)"
										style="display: flex;width: 205px;align-items: center;border-right: solid 1px #e1e1e1;">
										<div><span slot="title">{{getChildrenGroupItemName(item).text}}</span></div>
										<div v-if="getGroupLabelName(item).text"
											style="display: flex;align-items: center;margin-left: 10px;">
											<div :style="{'--bg':item.color1}" class="qbt"></div>
											<div :style="{backgroundColor:item.color1,color:item.color2}"
												style="height: 24px;display: flex;align-items: center;padding: 0px 6px;font-size: 12px;">
												{{getGroupLabelName(item).text}}
											</div>
										</div>
									</div>
								</template>
								<el-submenu :unique-opened="false" style="border-bottom:solid 1px #e1e1e1;"
									:key="childrenGroupIndex" :index="childrenGroupIndex + '-' + index"
									v-for="(childrenGroupItem,childrenGroupIndex) in (item.followChild?item.followChildList: item.child)">
									<template slot="title">
										<div
											style="display: flex;justify-content: space-between;width:185px;align-items: center;border-right: solid 1px #e1e1e1;font-weight: bold;">
											<span
												slot="title">{{getChildrenGroupItemName(childrenGroupItem).text}}</span>
										</div>
									</template>
									<el-menu-item v-if="childrenGroupItem.type == '1'"
										style="border-bottom:solid 1px #e1e1e1;"
										:style="{height:childrenGroupItem.type == '2'?'200px':'none'}"
										v-for="(childrenItem,childrenIndex) in childrenGroupItem.links"
										:key="childrenIndex"
										:index="childrenGroupIndex + '-'+ childrenIndex + '-' + index">
										<div @click.stop.prevent="hrefNavTo(childrenItem)"
											v-if="childrenGroupItem.type == '1'"
											style="display: flex;justify-content: space-between;width: 100%;align-items: center;">
											<span slot="title">{{getChildrenItemLinkName(childrenItem)}}</span>
										</div>
									</el-menu-item>
									<el-menu-item v-if="childrenGroupItem.type == '2'"
										style="border-bottom:solid 1px #e1e1e1;"
										:style="{height:childrenGroupItem.type == '2'?'200px':'none'}">
										<div style="width: 100%;align-items: center;"
											v-if="childrenGroupItem.type == '2'">
											<a @click.stop.prevent="hrefNavImgTo(childrenGroupItem)" target="_self"
												href="javascript:void(0)">
												<img style="width: 180px;height: 180px;margin-top: 10px;"
													:src="getChildImg(childrenGroupItem).url" />
											</a>
										</div>
									</el-menu-item>
								</el-submenu>
							</el-submenu>
							<el-menu-item style="border-bottom:solid 1px #e1e1e1;" @click="hrefNavTo(item)"
								v-if="item.followChild && item.cacheLinkIndex == '商品分类' ?!item.followChildList || item.followChildList.length == 0 : item.child && item.child.length == 0 " :index="index + ''">
								<div style="display: flex;width: 90%;align-items: center;">
									<span slot="title">{{getChildrenGroupItemName(item).text}}</span>

									<div v-if="getGroupLabelName(item).text"
										style="display: flex;align-items: center;margin-left: 10px;">
										<div :style="{'--bg':item.color1}" class="qbt"></div>
										<div :style="{backgroundColor:item.color1,color:item.color2}"
											style="height: 24px;display: flex;align-items: center;padding: 0px 6px;font-size: 12px;">
											{{getGroupLabelName(item).text}}
										</div>
									</div>
								</div>
							</el-menu-item>
						</div>
					</div>
				</el-menu>
			</van-popup>
		</div>
	</div>
</template>

<script>
	import {
		getDesignMenu,
	} from '../../api/nav.js'
	import {
		getUrl_name
	} from '../../api/all.js'
	export default {
		props: {
			all_setting: {
				type: Array,
				default: () => {
					return []
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
			equipment: {
				type: String,
				default: "pc"
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				disabledPop:false,
				enterChildTit: '',
				pClientWidth: -1,
				scrollWidth: -1,
				navEquipment: "pc",
				// type: '',
				show: false,
				loading: false,
				activeIndex: -1,
				list: [],
				popoverConfig: {
					color: "#000000", // 字体颜色
					width: 1200,
					isFull: true,
					bg: {
						bgType: "color", // color gradient
						bgGradient: '',
						bgColor: '#fff',
						bgImg: {
							url: '',
							type: "",
							position: "",
							width: "",
							height: ""
						},
					},
					border: {
						borderRadius: [0, 0, 0, 0],
						borderSize: [0, 0, 0, 0],
						radius: 0,
						type: "solid",
						px: 0,
						color: ""
					},
					padding: [0, 0, 0, 0],
					margin: [0, 0, 0, 0],
				}
			}
		},
		async mounted() {

			console.log('this.all_settingmounted', this.all_setting)
		
			if (this.all_setting.length > 0) {
				this.list = this.all_setting[1].tabList[0].data
			}
			console.log('this.list', this.list)
			if (this.equipment == 'pc') {
				if (this.all_setting.length > 0) {

					this.list.forEach(item => {
						if (!item.config) {
							this.$set(item, 'config', {
								align: "left",
								titColor: "#000000",
								color: "#000000", // 字体颜色
								width: 1200,
								isFull: true,
								bg: {
									bgType: "color", // color gradient
									bgGradient: '',
									bgColor: '#fff',
									bgImg: {
										url: '',
										type: "",
										position: "",
										width: "",
										height: ""
									},
								},
								border: {
									borderRadius: [0, 0, 0, 0],
									borderSize: [0, 0, 0, 0],
									radius: 0,
									type: "solid",
									px: 0,
									color: ""
								},
								padding: [0, 0, 0, 0],
								margin: [0, 0, 0, 0],
								titFontSize: 18,
								titChildFontSize: 14
							})
						} else {
							if (!item.config.titFontSize) {
								this.$set(item.config, 'titFontSize', 18)
							}
							if (!item.config.titChildFontSize) {
								this.$set(item.config, 'titChildFontSize', 14)
							}
						}
						if (item.child) {

							item.child.forEach(childItem => {
								if (!childItem.configWidth) {
									this.$set(childItem, 'configWidth', 250)
								}
							})
						}
					})

					console.log('this.list', this.list)
				}



				this.$nextTick(() => {
					let elPopover = document.querySelectorAll('.el-popover')
					console.log('elPopover', elPopover)
				})

				this.$nextTick(() => {
					let elPopover = document.querySelectorAll('.el-popover')
					console.log('elPopover', elPopover)
					for (let i = 0; i < elPopover.length; i++) {
						if (this.list[i].config.bg.bgType == 'color') {
							elPopover[i].style.backgroundColor = this.list[i].config.bg.bgColor
						} else {
							let bg = this.cssStringToObject(this.list[i].config.bg.bgGradient)
							for (let key in bg) {
								elPopover[i].style[key] = bg[key]
							}
						}
						elPopover[i].style.padding = '0px'
						// elPopover[i].style.paddingTop = this.list[i].config.padding[0] + 'px'
						// elPopover[i].style.paddingLeft = this.list[i].config.padding[1]+ 'px'
						// elPopover[i].style.paddingBottom = this.list[i].config.padding[2]+ 'px'
						// elPopover[i].style.paddingRight = this.list[i].config.padding[3]+ 'px'


						// 		elPopover[i].style.marginTop = this.list[i].config.margin[0] + 'px'
						// 		elPopover[i].style.marginLeft = this.list[i].config.margin[1]+ 'px'
						// 		elPopover[i].style.marginBottom = this.list[i].config.margin[2]+ 'px'
						// 		elPopover[i].style.marginRight = this.list[i].config.margin[3]+ 'px'

						if (this.list[i].config.border.type && this.list[i].config.border.color) {
							elPopover[i].style.borderTop =
								`${this.list[i].config.border.type} ${this.list[i].config.border.borderSize[0]}px ${this.list[i].config.border.color}`
							elPopover[i].style.borderLeft =
								`${this.list[i].config.border.type} ${this.list[i].config.border.borderSize[1]}px ${this.list[i].config.border.color}`
							elPopover[i].style.borderBottom =
								`${this.list[i].config.border.type} ${this.list[i].config.border.borderSize[2]}px ${this.list[i].config.border.color}`
							elPopover[i].style.borderRight =
								`${this.list[i].config.border.type} ${this.list[i].config.border.borderSize[3]}px ${this.list[i].config.border.color}`
						}

					}
				})
			}




			// // 使用方法
			// if (this.type != 'build') {
			// 	this.loading = true
			// 	let wsid = this.$cookies.get("wsid")
			// 	let data = await getDesignMenu({
			// 		wsid
			// 	})
			// 	this.list = data.data.data
			// 	this.loading = false
			// } else {
			// 	this.list = this.selectdItem.compontChildren[0].data.list
			// }
			// if(this.type != 'design'){
			// 	this.$nextTick(()=>{
			// window.addEventListener('resize', this.changeFontSize);
			// this.changeFontSize()
			// 	})
			// }
		},

		methods: {
			getPopoverFullWidth(item) {
				let w = 20
				// if(parseInt(item.config.padding[1])> 0) {
				// 	w = parseInt(item.config.padding[1]) + w
				// }
				// if(parseInt(item.config.padding[3])> 0) {
				// 	w = parseInt(item.config.padding[3])+ w
				// }
				return `calc(100vw - ${w}px)`
			},
			getChildTitColor(color, hoverColor, titIndex) {
				console.log('getChildTitColorcolor', color)
				let col = color
				if (titIndex == this.enterChildTit && hoverColor) {
					col = hoverColor
				}
				return col
			},
			cssStringToObject(cssString) {
				const styleObject = {};

				// 移除所有注释（可选）
				const cleanedCss = cssString.replace(/\/\*[\s\S]*?\*\//g, '');

				// 分割每条规则
				const rules = cleanedCss.split(';').filter(rule => rule.trim() !== '');

				rules.forEach(rule => {
					const [property, value] = rule.split(':').map(item => item.trim());
					if (property && value) {
						// 转换属性名为驼峰式（如 background-color -> backgroundColor）
						const camelCaseProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
						styleObject[camelCaseProperty] = value;
					}
				});

				return styleObject;
			},
			getPopoverPadding(e) {
				let style = {
					paddingTop: e.config.padding[0] + 'px',
					paddingBottom: e.config.padding[2] + 'px',
					paddingLeft: e.config.padding[1] + 'px',
					paddingRight: e.config.padding[3] + 'px'
				}
				return style
			},
			getPadding(e) {
				let style = {
					paddingTop: e.preStyle.selfStyle.padding[0] + 'px',
					paddingBottom: e.preStyle.selfStyle.padding[1] + 'px',
					paddingLeft: e.preStyle.selfStyle.padding[2] + 'px',
					paddingRight: e.preStyle.selfStyle.padding[3] + 'px'
				}
				return style
			},
			getBg(e) {
				let style = {}
				if (e.preStyle.selfStyle.bg.color && e.preStyle.selfStyle.bg.bgtype == 'color') {
					style.background = e.preStyle.selfStyle.bg.color
				}
				if (e.preStyle.selfStyle.bg.bgtype && e.preStyle.selfStyle.bg.bgtype == 'img') {
					if (e.preStyle.selfStyle.bg.img) {

						let backgroundImage = `url(${e.preStyle.selfStyle.bg.img})`

						if (e.preStyle.selfStyle.bg.bgImgWidth) {
							style.backgroundSize = e.preStyle.selfStyle.bg.bgImgWidth + 'px';
						} else {
							style.backgroundSize = '100%';
						}
						if (e.preStyle.selfStyle.bg.bgImgHeigth) {
							style.backgroundSize = style.backgroundSize + ' ' + (e.preStyle.selfStyle.bg.bgImgHeigth +
								'px')
						} else {
							style.backgroundSize = style.backgroundSize + ' 100%'
						}
						if (e.preStyle.selfStyle.bg.type) {
							style.backgroundRepeat = e.preStyle.selfStyle.bg.type
						}
						if (e.preStyle.selfStyle.bg.position) {
							style.backgroundPosition = e.preStyle.selfStyle.bg.position
						}
						style.backgroundImage = backgroundImage
						if (e.preStyle.selfStyle.bg.type) {
							style.backgroundRepeat = e.preStyle.selfStyle.bg.type
						}
					}
				}
				if (e.preStyle.selfStyle.bg.bgtype == 'gradient') {
					style = {
						...style,
						...this.cssStringToObject(e.preStyle.selfStyle.bg.bgGradient)
					}
				}

				return style
			},


			getBorderRadius() {
				let style = {}
				style.borderRadius =
					`${this.selectdItem.preStyle.selfStyle.border.borderRadius[0]}px ${this.selectdItem.preStyle.selfStyle.border.borderRadius[1]}px ${this.selectdItem.preStyle.selfStyle.border.borderRadius[2]}px ${this.selectdItem.preStyle.selfStyle.border.borderRadius[3]}px`
				console.log('getBorderRadius', style)
				return style
			},
			getBorder() {
				if (this.selectdItem.preStyle.selfStyle.border.type && this.selectdItem.preStyle.selfStyle.border.color) {
					let style = {}
					style.borderTop =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[0]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					style.borderLeft =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[1]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					style.borderBottom =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[2]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					style.borderRight =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[3]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					return style
				}
			},




			getChildrenItemLinkName(item) {
				console.log('getChildrenItemLinkName', item)
				let str = ''
				if (item.linkList) {
					item.linkList.forEach(item => {
						if (item.language == this.systemConfig.locale) {
							str = item.text
						}
					})
				}
				return str
			},
			hrefNavImgTo(item) {
				let imgItem = item.imgLink[item.imgLink.length - 1]
				this.hrefNavTo(imgItem.link)
				console.log('imgItem.link', imgItem.link)
			},
			async hrefNavTo(item) {
				console.log('this.$refs.popoverRef',this.$refs.popoverRef)
				if(this.equipment == 'pc'){
					this.$refs.popoverRef.forEach(popover=>{
						popover.doClose();
					})
				}
				console.log('hrefNavToitem', item)

				console.log('hrefNavTo', item)
				if (this.type == 'design') {
					return
				}

				// 热销商品
				// 最新商品
				// 浏览最多
				// 所有商品
				if (item.cacheLinkIndex == '热销商品') {
					this.$router.push({
						path: '/categories_products/hot'
					})
					this.show = false
					return
				}
				if (item.cacheLinkIndex == '最新商品') {
					this.$router.push({
						path: '/categories_products/new'
					})
					this.show = false
					return
				}

				if (item.cacheLinkIndex == '浏览最多') {
					this.$router.push({
						path: '/categories_products/visit'
					})
					this.show = false
					return
				}
				if (item.cacheLinkIndex == '所有商品') {
					this.$router.push({
						path: '/categories_products/all'
					})
					this.show = false
					return
				}




				if (item.cacheLinkIndex == '首页') {
					this.$router.push({
						path: '/'
					})
					this.show = false
					return
				}


				if (item.cacheLinkIndex == '商品分类') {
					try {
						this.loading = true
						this.show = false
						const urlData = await getUrl_name({
							type: "categories",
							id: item.link.id
						})


						this.$router.push({
							path: '/categories/' + urlData.data.data
						})
						this.loading = false
					} catch (e) {
						console.log('e', e)
						this.loading = false
					}
					return
				}
				if (item.cacheLinkIndex == '商品') {

					try {
						this.loading = true
						this.show = false
						const urlData = await getUrl_name({
							type: "products",
							id: item.link.id
						})
						this.$router.push({
							path: '/products/' + urlData.data.data
						})
						this.loading = false
					} catch (e) {
						this.loading = false
					}
					return
				}
				let url = item.link.url
				if (item.link.type == '站内链接') {
					// 判断是否是站内链接
					console.log('item.link', item.link)
					console.log(window.location.host)
					if (item.link.name.indexOf(window.location.host) != -1) {
						let arr = item.link.name.split(window.location.host)
						this.$router.push({
							path: arr[1],
						})
						this.show = false
						return
					} else {
						this.show = false
						window.open(item.link.name);
						return
					}
				}
				this.show = false
				if (url) {
					this.$router.push({
						path: '/' + url,
					})
				}

			},
			getChildImg(item) {
				let imgObj = {}
				item.imgLink.forEach(imgItem => {
					if (this.systemConfig.locale == imgItem.language) {
						imgObj = imgItem
					}
				})
				return imgObj.img
			},
			getGroupLabelName(item) {
				let label = {}
				item.label.forEach(textItem => {
					if (this.systemConfig.locale == textItem.language) {
						label = textItem
					}
				})
				return label
			},
			getChildrenGroupItemName(item) {
				console.log('getChildrenGroupItemName', item)
				let textObj = {}
				item.text.forEach(textItem => {
					if (this.systemConfig.locale == textItem.language) {
						textObj = textItem
					}
				})
				return textObj
			},
			changeFontSize() {
				const element = document.querySelector('.box');
				const pElement = document.querySelector('.pBox');
				console.log('pElement', pElement)
				if (element) {
					if (this.isOverflowing(element)) {
						console.log('元素溢出');
						this.pClientWidth = pElement.clientWidth
						this.scrollWidth = element.scrollWidth
						this.navEquipment = 'phone'
					} else {
						console.log('元素没有溢出');
						this.navEquipment = 'pc'
					}
				}
				if (this.pClientWidth != -1) {
					if (pElement.clientWidth > this.scrollWidth) {
						this.navEquipment = 'pc'
					}
				}
			},


			isOverflowing(element) {
				return element.scrollWidth > element.clientWidth;
			},


			getLanguage(item) {
				console.log('item', item)
				let str = ''
				item.descriptions.forEach(item => {
					if (item.locale == this.systemConfig.locale) {
						str = item.name
					}
				})
				return str
			},
			handleClose() {

			},
			handleOpen() {

			},
			getPathFromUrl(url) {
				const match = url.match(/^https?:\/\/[^/]+(\/[^?#]*)/);
				return match ? match[1] : '/';
			},

			headNavTo(e) {
				if (!e) {
					return
				}
				console.log(e)
				console.log(window.location.host)
				const path = this.getPathFromUrl(e.link);
				if (this.type != 'build') {
					let arr = e.link.split(window.location.host)
					if (this.$route.path == arr[1]) {}
					if (this.$route.path == '/') {
						this.$router.push({
							path: arr[1],
						})
						this.show = false
						window.location.reload()
					} else {
						this.show = false
						this.$router.replace({
							path: arr[1],
							// query: {
							// 	nav: new Date().getTime()
							// }
						})
					}
					// window.location.reload()
				} else {
					let arr = e.link.split(window.location.host)
					if (this.$route.path == arr[1]) {}
					if (this.$route.path == '/') {
						this.$router.push({
							path: arr[1],
						})
						this.show = false
						window.location.reload()
					} else {
						this.show = false
						this.$router.replace({
							path: arr[1],
							// query: {
							// 	nav: new Date().getTime()
							// }
						})
					}
					// window.location.reload()
				}

				// if (e.new_window) {
				// 	window.open(e.link, '_blank')
				// } else {
				// 	window.open(e.link, '_self')
				// }
			},
			navTo(e) {
				console.log('e', e)
				if (!e) {
					return
				}
				const path = this.getPathFromUrl(e.link.link);
				if (this.type != 'build') {
					let arr = e.link.link.split(window.location.host)
					if (this.$route.path == arr[1]) {}
					if (this.$route.path == '/') {
						this.$router.push({
							path: arr[1],
						})
						this.show = false
						window.location.reload()
					} else {
						this.show = false
						this.$router.replace({
							path: arr[1],
							// query: {
							// 	nav: new Date().getTime()
							// }
						})
					}
				} else {
					let arr = e.link.link.split(window.location.host)
					if (this.$route.path == arr[1]) {}
					if (this.$route.path == '/') {
						this.$router.push({
							path: arr[1],
						})
						this.show = false
						window.location.reload()
					} else {
						this.show = false
						this.$router.replace({
							path: arr[1],
							// query: {
							// 	nav: new Date().getTime()
							// }
						})
					}
				}


				// if (e.link.new_window) {
				// 	window.open(e.link.link, '_blank')
				// } else {
				// 	window.open(e.link.link, '_self')
				// }
			},
			mouseenterMore(index, item) {
				if (item.children_group) {
					this.activeIndex = index
				}

			},
			mouseleaveMore(type) {
				let that = this
				setTimeout(() => {
					that.activeIndex = -1
				}, 100)

			}
		}
	}
</script>

<style scoped lang="scss">
	.popover {

		/* 单独显示Webkit滚动条 */
		&::-webkit-scrollbar {
			display: block;
			/* 显示滚动条 */
			width: 8px;
			/* 宽度 */
			height: 8px;
			/* 水平滚动条高度 */
		}

		&::-webkit-scrollbar-thumb {
			background: #888;
			/* 滑块颜色 */
			border-radius: 4px;
		}

		&::-webkit-scrollbar-thumb:hover {
			background: #555;
			/* 悬停颜色 */
		}

		&::-webkit-scrollbar-track {
			background: #f1f1f1;
			/* 轨道颜色 */
		}
	}

	.qbt {
		width: 0;
		height: 0;
		border-right: 12px solid var(--bg);
		border-top: 12px solid transparent;
		border-bottom: 12px solid transparent;
	}

	.qipao {
		padding: 0px 4px 4px 4px;
		color: #fff;
		text-align: center;
		/* 箭头靠右边 */
		/* clip-path: polygon(0 0, 88% 0, 88% 35%, 95% 50%, 88% 65%, 88% 100%, 0 100%); */
		/* 箭头靠下边 */
		clip-path: polygon(0 0, 100% 0, 100% 85%, 35% 85%, 30% 100%, 50% 85%, 0% 85%);
		/* 箭头靠左边 */
		/* clip-path: polygon(5% 0, 100% 0, 100% 100%,5% 100%, 5% 65%,0 50%,5% 35%); */
		/* 箭头靠下边 */
		/* clip-path: polygon(0 15%, 25% 15%, 30% 0,35% 15%, 100% 15%,100% 100%,0% 100%); */
		/* clip-path: polygon(0 15%, 25% 15%, 30% 0,35% 15%, 100% 15%,100% 100%,0% 100%); */
		font-size: 14px;
		display: flex;
		justify-content: center;
		align-items: center;
		top: -10px;
		min-width: 36px;

	}

	.linktit:hover {
		cursor: pointer;
		color: var(--hover);
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s;
	}

	.fade-enter,
	.fade-leave-to

	/* .fade-leave-active below version 2.1.8 */
		{
		opacity: 0;
	}

	.nav_item {

		cursor: pointer;
		margin-top: 4px;
		margin-bottom: 4px;
		/* margin-left: 4px; */
		/* margin-right: 4px; */

		display: flex;
	}

	.nav_item:hover {
		color: var(--hover);
	}

	.more_item {
		/* background-color: aqua; */
		display: flex;
		align-items: center;
		/* padding: 20px; */
		/* position: fixed; */
		/* background-color: 'none'; */
		/* box-shadow: 1px 1px 15px #a8a8a8; */
		/* margin-top: 10px; */
		display: flex;
		justify-content: center;
		/* z-index: 100; */
		/* 	top:10px;
		left: 10px; */
	}
</style>